var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['beta', _vm.sizeClass],attrs:{"data-view-component":"true","label":"Beta"}},[_vm._v("\n  "+_vm._s(_vm.$t('SIDEBAR.BETA'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }